import {COMPTE_ROUTES as compteRoutes} from "~/api/routes";
import {CREER_VIA as creer_via} from "~/api/variables";
import vue from 'vue'
import { parse } from "@fortawesome/fontawesome-svg-core";
const page = localStorage.getItem('CLIENT_PAGE');
export const state = () => ({
  comptes: [],
  comptesList: [],
  details: null,
  pagination:{},
  close:false,
  isRequesting:false
});
export const getters = {
  allComptes: state => state.comptes
};
export const mutations = {
  COMPTES_LOAD(state) {
    //state.isLoading = true;
    state.hasError = false;
    state.comptes = [];
    //state.page = page;
  },
  COMPTES_SUCCES(state, comptes) {
    state.comptes = comptes;
    //state.pagination = params.payload.pagination;
    //state.filters = params.filters || state.filters;
  },
  COMPTES_ERROR(state) {
    state.comptes = [];
    state.hasError = true;
  },
  COMPTES_LOADED(state) {
    //state.isLoading = false;
  },
  COMPTES_ALL_SUCCES(state, comptes) {
    state.comptesList = comptes;
  },
  COMPTES_PAGINATION(state,pagination){
    delete pagination.data;
    state.pagination = pagination
  },
  COMPTE_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  COMPTE_PROCESSING_END(state) {
    //state.isLoading = false;
  },
  COMPTE_SUCCES(state, details) {
    state.details = details
    //state.isLoading = false;
  },
  COMPTE_ERROR(state) {
    //state.isLoading = false;
  },
  COMPTES_ALL_ERROR(state) {

  },
  CLOSE_MODAL(state,close){
    state.close = close;
  },
  IS_REQUESTING(state,isRequesting){
    state.isRequesting = isRequesting
  },
  REMOVE_COMPTE(state, compte_id) {
    state.comptes = state.comptes.filter(element => element.compte_id !== compte_id);
    state.comptesList = state.comptesList.filter(element => element.compte_id !== compte_id);

  },
  REMOVE_COMPTE_FROM_LIST(state, compte) {
    state.comptes = state.comptes.filter(element => element.compte_id !== compte.compte_id);

  },
  UPDATE_AN_COMPTE(state, compte) {
    let index = state.comptes.findIndex((elem) => elem.compte_id === compte.compte_id);
    state.comptes = state.comptes.filter(element => element.compte_id !== compte.compte_id);
    state.comptes.splice(index, 0, compte);
    index = state.comptesList.findIndex((elem) => elem.compte_id === compte.compte_id);
    state.comptesList= state.comptesList.filter(element => element.compte_id !== compte.compte_id);
    state.comptesList.splice(index, 0, compte);
  },
  ADD_COMPTE_TO_LIST(state, compte) {
    state.comptes.unshift(compte);
  },
  ADD_COMPTELIST_TO_LIST(state, compte) {
    let index = state.comptesList.findIndex((elem) => elem.compte_id === compte.compte_id);
    if (index == -1)
    state.comptesList.unshift(compte);
    else
    {
      state.comptesList= state.comptesList.filter(element => element.compte_id !== compte.compte_id);
      state.comptesList.splice(index, 0, compte);
    }

  },
  SET_POINTS(state, params){
    state.comptes.map(i => {
      if(i.compte_id === params.compte_id) {
        i.point_fidelite =i.point_fidelite ? `${parseInt(i.point_fidelite) + parseInt(params.points)}` : params.points ;
      }
    });
  },
  REDUCE_POINTS(state, params)
  {
    state.comptes.map(i => {
      if(i.compte_id === params.compte_id) {
        i.point_fidelite =i.point_fidelite ? `${parseInt(i.point_fidelite) - parseInt(params.points)}` : 0;
      }
    });
  },
  UPDATE_COMPTE_ID(state, compte_id) {
    // updating client and comptes and also comptesList see: BC-805
    state.comptesList.map(i => {
      if(i.compte_id === 0) {
        i.compte_id = parseInt(compte_id);
      }
    });
    state.comptes.map(i => {
      if(i.compte_id === 0) {
        i.compte_id = parseInt(compte_id);
      }
    });
  }
};

export const actions = {
  async getComptes({commit},params={}) {
    const page = localStorage.getItem('CLIENT_PAGE') | 1;
    params.page = params.page ? params.page : page;
    try{
      commit('COMPTES_LOAD');
      commit('IS_REQUESTING',true);
      const queryUrl = {...compteRoutes.list};
      queryUrl.endPoint += '&page=' +params.page;
      this.$api.request(queryUrl,{},params)
        .then(response => {
          if(response.payload.current_page > 1 && (!response.payload.data || response.payload.data.length===0)){
            this.dispatch('compte/getComptes',{
              page:1
            });
          }
          commit('COMPTES_SUCCES', response.payload.data);
          commit('COMPTES_PAGINATION', response.payload);
        })
        .catch(error => {
          commit('COMPTES_ERROR');
        })
        .finally(() => {
          commit('COMPTES_LOADED');
          commit('IS_REQUESTING',false);
        });
    }catch(e){
    }
  },
  async allComptes({commit}) {
    this.$api.request(compteRoutes.cards)
      .then(response => {
        commit('COMPTES_ALL_SUCCES', response.payload);
      })
      .catch(error => {
        commit('COMPTES_ALL_ERROR');
      })
  },
  async setCompte({commit}, params) {
    commit('COMPTE_SUCCES', params);
  },
  async getCompte({commit}, params) {
    // commit('COMPTE_SUCCES', params);
    commit('COMPTE_PROCESSING_START');
    await this.$api.request(compteRoutes.get, {id: params.compte_id})
      .then(response => {
        commit('COMPTE_SUCCES',response.payload);
      })
      .catch(error => {
        commit('COMPTE_ERROR');
      })
      .finally(() => commit('COMPTE_PROCESSING_END'));
  },
  async deleteCompte({commit,state}, params) {
    commit('COMPTE_PROCESSING_START');
    await this.$api.request(compteRoutes.delete, {id: params.compte_id})
      .then(response => {
        //commit('COMPTE_SUCCES', response);
        try{
          commit('REMOVE_COMPTE_FROM_LIST', params);
          if(state.comptes.length===0){
            this.dispatch('compte/getComptes',{
              page:1
            });
          }
        }catch (e) {
        }
      })
      .catch(error => {
        commit('COMPTE_ERROR');
      })
      .finally(() => commit('COMPTE_PROCESSING_END'));
  },
  async updateCompte({commit}, params) {
    commit('COMPTE_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(compteRoutes.update, {id: params.compte_id}, {...params,...creer_via})
      .then(response => {
        //commit('COMPTE_SUCCES', response);
        commit('CLOSE_MODAL',true);
        commit('UPDATE_AN_COMPTE', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('COMPTE_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('COMPTE_PROCESSING_END')
      });
  },
  async createCompte({commit}, params) {
    commit('COMPTE_PROCESSING_START');
    commit('CLOSE_MODAL',false);
    commit('IS_REQUESTING',true);
    await this.$api.request(compteRoutes.create, {}, {...params,...creer_via})
      .then(response => {
        //commit('COMPTE_SUCCES', response);
        commit('CLOSE_MODAL',true);
        commit('ADD_COMPTE_TO_LIST', response.payload);
      })
      .catch(error => {
        commit('CLOSE_MODAL',false);
        commit('COMPTE_ERROR');
      })
      .finally(() => {
        commit('IS_REQUESTING',false);
        commit('COMPTE_PROCESSING_END')
      });
  },
  async addCompte({commit}, params) {
    commit('ADD_COMPTELIST_TO_LIST', params);
  },
  async updateCompteId({commit}, compte_id) {
    commit('UPDATE_COMPTE_ID', compte_id);
  },
  async setPoints({commit}, params) {
    return new Promise((resolve, reject) => {   this.$api.request(compteRoutes.addpoints, {},params).then(resp =>{

      vue.$toast.success(resp._response.message);
      commit('SET_POINTS', params);
      resolve();
    });
    });
    // commit('UPDATE_COMPTE_ID', compte_id);
  },
  async reducePoints({commit}, params) {
    return new Promise((resolve, reject) => {
      this.$api.request(compteRoutes.reducepoints, {},params).then(resp =>{

      vue.$toast.success(resp._response.message);
      commit('REDUCE_POINTS', params);
        resolve();
    });
    });
  },
  async sendNotif({ commit }, params) {
    commit('COMPTE_PROCESSING_START');
    commit('IS_REQUESTING', true);
    try {
      const response = await this.$api.request(compteRoutes.sendNotif, {}, params);
      vue.$toast.success(response._response.message);
    } catch (error) {
      vue.$toast.error('Failed to send notification');
      commit('COMPTE_ERROR');
    } finally {
      commit('IS_REQUESTING', false);
      commit('COMPTE_PROCESSING_END');
    }
  },
};
